const SvgArrowLeftWhite = (props) => {
	return (
		<svg
			width="12"
			height="18"
			viewBox="0 0 12 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M0.870354 8.99995C0.870354 8.67735 0.993528 8.3548 1.23936 8.10885L8.97903 0.369254C9.47137 -0.123085 10.2696 -0.123085 10.7618 0.369254C11.2539 0.861395 11.2539 1.65948 10.7618 2.15186L3.91326 8.99995L10.7615 15.8481C11.2537 16.3404 11.2537 17.1384 10.7615 17.6305C10.2694 18.1231 9.47113 18.1231 8.97879 17.6305L1.23912 9.89105C0.993249 9.64498 0.870354 9.32243 0.870354 8.99995Z"
				fill="white"
			/>
		</svg>
	);
};

export default SvgArrowLeftWhite;
